import React, { useEffect, useRef, useState } from "react";
import "./invoiceGeneration.scss";
import { singleImagePreview } from "../../utils/invoiceGeneration/commonFunctions";
import {
  InputGoodDataInput,
  BomInstallationInput,
  BomHeaderDataInput,
  BomHeaderDataError,
} from "../../constant/billOfMaterial";
import {
  BomInputType,
  BomInstallationType,
  BomOutputType,
  BomHeaderType,
  SelectOption,
  BomTotalType,
  BomHeaderErrorType,
  isAccordianType,
  PersistInputType,
} from "../../commonTypes/billOfMaterial";
import { connect } from "react-redux";
import {
  postBomDataAction,
  resetInvoiceGenerationError,
  resetSingleBomData,
  resetSingleBomTemplateData,
  resetSuccess,
} from "../../redux/invoiceGeneration";
import { resetSession } from "../../redux/auth";
import { RootState } from "../../redux/rootReducers";
import {
  BatchManagementItem,
  BusinessAddressListType,
  StockItemQuantityRateType,
} from "../../redux/clientSettings/clientSettingTypes";
import {
  getAllStockItemListAction,
  getMultipleStockItemQuantityAction,
  getStockMappedBatchListAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMappedStockBatchList,
  resetMappedStockBatchListTotalCount,
  resetMessage,
  resetMultipleStockItemQuantityData,
  resetStockItemList,
  resetStockItemListTotal,
} from "../../redux/clientSettings";
import { changeToDecimel, formatDate } from "../../utils/commonFunctions";
import { BomDataPayloadType } from "../../commonTypes/invoiceGenerationTypes";
import {
  GetAllStockItemListPayloadType,
  GetBatchListPayloadType,
  GetStockMappedBatchListPayloadType,
  StockMultipleItemQuantityRatePayloadType,
} from "../../commonTypes/clientSettingsTypes";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import useDebounce from "../../customHooks/useDebounce";
import { ImageDataType } from "../../commonTypes/fileManagerTypes";
import MultipleUpload from "../../components/commons/Upload/MultipleUpload";
import ImageModal from "../AdminReports/OpenItemsProgressReports/ImageModal";
import toast, { Toaster } from "react-hot-toast";
import BomAddEditFormDetails from "../../components/InvoiceGeneration/BillOfMaterial/BillOfMaterialAddEditForm/BomAddEditFormDetails";
import EditBillOfMaterial from "./EditBillOfMaterial";

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  currencySign: string | undefined;
  message: string | null;
  businessAddressList: [] | BusinessAddressListType[];
  allStockItemList: any;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  lockBOMEntriesDate: null | string;
  stockItemListTotal: number;
  stockFetching: boolean;
  fileManagerFetching: boolean;
  dispatchResetStockItemList: () => void;
  dispatchResetStockItemTotal: () => void;
  dispatchResetSingleBomTemplateData: () => void;
  dispatchResetBomSingleDataAction: () => void;
  dispatchResetMultipleStockItemData: () => void;
  multipleStockItemQuantityData: StockItemQuantityRateType[];
  dispatchPostBomDataAction: (data: BomDataPayloadType) => void;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  dispatchGetMultipleStockItemQuantityAction: (
    data: StockMultipleItemQuantityRatePayloadType
  ) => void;
  dispatchResetSessionAction: () => void;
  dispatchResetInvoiceGenerationError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetInvoiceGenerationSuccess: () => void;
  dispatchGetStockMappedBatchListAction: (data: GetStockMappedBatchListPayloadType) => void;
  dispatchResetMappedStockBatchListTotalCount: () => void;
  mappedStockBatchListTotalCount: number;
  mappedStockBatchList: BatchManagementItem[] | [];
  dispatchResetMappedStockBatchList: () => void;
  batchSuccess: null | number;
  batchError: null | string;
  batchMessage: string | null;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingMessage: () => void;

};

const AddBillOfMaterial = ({
  history,
  token,
  fetching,
  success,
  error,
  message,
  statusCode,
  stockItemListTotal,
  lockBOMEntriesDate,
  dispatchResetMultipleStockItemData,
  dispatchGetAllStockItem,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetStockItemList,
  dispatchResetStockItemTotal,
  dispatchResetSingleBomTemplateData,
  dispatchResetMappedStockBatchListTotalCount,
  dispatchGetStockMappedBatchListAction,
  mappedStockBatchListTotalCount,
  mappedStockBatchList,
  dispatchResetMappedStockBatchList,
  batchSuccess,
  batchError,
  batchMessage,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingMessage
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const company_name =
    history &&
      history.location &&
      history.location.state &&
      history.location.state.company_name
      ? history.location.state.company_name
      : "";

  const client_code =
    history &&
      history.location &&
      history.location.state &&
      history.location.state.client_code
      ? history.location.state.client_code
      : "";
  const containerName = `clientcontainer${client_code}`;
  const template =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.template;
  const [inputData, setInputData] = useState<BomInputType[]>([
    { ...InputGoodDataInput },
  ]);
  const [outputData, setOutputData] = useState<BomOutputType[] | []>([]);
  const [bomInstallationData, setBomInstallationData] = useState<
    BomInstallationType[]
  >([{ ...BomInstallationInput }]);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [bomHeaderData, setBomHeaderData] = useState<BomHeaderType>({
    ...BomHeaderDataInput,
  });
  const [bomTempHeaderData, setBomTempHeaderData] = useState<BomHeaderType>({
    ...BomHeaderDataInput,
  });
  const [bomHeaderError, setBomHeaderError] = useState<BomHeaderErrorType>({
    ...BomHeaderDataError,
  });
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [isAccordianOpen, setIsAccordianOpen] = useState<isAccordianType>({
    input: true,
    output: false,
    installation: false,
  });
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [uploadData, setUploadData] = useState<any[]>([]);
  const [commentData, setCommentData] = useState("");
  const [finalStockItemOptions, setFinalStockItemOptions] = useState<
    SelectOption[] | []
  >([]);
  const [finalStockItemDetailsOptions, setFinalStockItemDetailsOptions] =
    useState<SelectOption[] | []>([]);
  const [persistInput, setPersistInput] = useState<PersistInputType>({
    inputType: "",
    type: "",
    index: "",
  });
  const [persistHeaderQuantity, setPersistHeaderQuantity] = useState<number>(1);
  const [total, setTotal] = useState<{
    input: BomTotalType;
    output: BomTotalType;
    totalAdditionalCost?: number;
  }>({
    input: { qty: 0, amount: 0 },
    output: {
      qty: 0,
      amount: 0,
    },
    totalAdditionalCost: 0,
  });
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [stockItemText, setStockItemText] = useState("");
  const [limit, setLimit] = useState<number>(60);
  const [offset, setoffset] = useState<number>(0);
  const [batchOffset, setBatchOffset] = useState(0)
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [modal, toggleModal] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isItem: boolean; isRate: boolean }>({
    isItem: false,
    isRate: false,
  });
  const [useTemplateId, setUseTemplateId] = useState<string>("");
  const [isTemplate, setIsTemplate] = useState<boolean>(false);
  const [isEntryLocked, setIsEntryLocked] = useState(false);
  const [dateOfBom, setDateOfBom] = useState<any>("");
  const [finalBatchNumberOptions, setFinalBatchNumberOptions] =
    useState<SelectOption[] | []>([]);
  const [selectedStockId, setSelectedStockId] = useState("")
  const [selectedInputItemStockId, setSelectedInputItemStock] = useState("")
  // const [expandedRows, setExpandedRows] = useState({});
  const [inputItemBatchIndex, setInputItemBatchIndex] = useState<null | number>(null)
  const [dropDownType, setDropDownType] = useState<string>("")
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    toast.remove();
    dispatchResetMultipleStockItemData();
    dispatchResetStockItemList();
    dispatchResetStockItemTotal();
    setBomHeaderError({ ...BomHeaderDataError });
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetSingleBomTemplateData();
    dispatchResetMappedStockBatchListTotalCount();
    dispatchResetMappedStockBatchList();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetClientSettingMessage();
    if (!useTemplateId) {
      let tempInputData =
        inputData?.length > 0 ? JSON.parse(JSON.stringify(inputData)) : [];

      tempInputData?.map((item: BomInputType) => {
        return (item.amount = (+item.rate * +item.quantity).toString());
      });
      setInputData([...tempInputData]);
    }
  }, []);
  useEffect(() => {
    if (token && stockItemListTotal && !useTemplateId) {
      if (offset <= +stockItemListTotal) {
        let finalData = {
          token,
          client_code,
          limit,
          offset,
          search_term: stockItemText,
        };
        dispatchGetAllStockItem(finalData);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [offset]);


  useEffect(() => {
    if (
      batchMessage?.includes("Batch added successfully") && selectedStockId
    ) {
      dispatchResetMappedStockBatchList();
      dispatchResetClientSettingsError();
      dispatchResetClientSettingMessage();
      toast.success(
        `Batch has been added successfully`,

        {
          duration: 2000,
        }
      );
      if (token) {

        let finalData = {
          token,
          clientCode: client_code,
          stockId: selectedStockId,
          isEnable: 1,

        };
        dispatchGetStockMappedBatchListAction(finalData);
      }



    }
  }, [batchMessage, selectedStockId]);
// Future use
  // useEffect(() => {
  //   dispatchResetMappedStockBatchList();

  //   if (selectedStockId) {
  //     let finalData = {
  //       token,
  //       clientCode: client_code,
  //       stockId: selectedStockId,
  //       isEnable: 1,
  //     };
  //     dispatchGetStockMappedBatchListAction(finalData);

  //     // setSelectedStockId("");
  //   }
  // }, [selectedStockId]);

  

  useEffect(() => {
    if (!useTemplateId) {
      let data = [
        bomHeaderData?.primaryItem?.value?.toString(),
        ...inputData?.map((item: BomInputType) =>
          item?.itemName?.value?.toString()
        ),
        ...outputData?.map((item: BomInputType) =>
          item?.itemName?.value?.toString()
        ),
      ];

      if (data?.length > 0) {
        let filterData: any = finalStockItemOptions?.filter((item: any) => {
          return !data?.includes(item?.value?.toString());
        });

        setFinalStockItemDetailsOptions([...filterData]);
      } else {
        setFinalStockItemDetailsOptions([...finalStockItemOptions]);
      }
    }
  }, [finalStockItemOptions, inputData, outputData, bomHeaderData]);


  const handletoggleRowInput = (index: any, type: any) => {
    let tempInputData =
      inputData?.length > 0 ? JSON.parse(JSON.stringify(inputData)) : [];

    let newInputData = tempInputData?.map((item: any, idx: number) => idx === index ? { ...item, isOpen: !item?.isOpen } : item)

    setInputData([...newInputData])

  };

  const handletoggleRowOutput = (index: any, type: any) => {
    let tempOutputData =
      outputData?.length > 0 ? JSON.parse(JSON.stringify(outputData)) : [];

    let newOutputData = tempOutputData?.map((item: any, idx: number) => idx === index ? { ...item, isOpen: !item?.isOpen } : item)

    setOutputData([...newOutputData])
  };


  const fetchNewData = () => {
    let finalData = {
      token,
      client_code,
      limit,
      offset,
      search_term: stockItemText,
    };
    dispatchGetAllStockItem(finalData);
  };

  useDebounce(
    () => {
      if (!useTemplateId) {
        if (stockItemText) {
          fetchNewData();
        } else {
          let finalData = {
            token,
            client_code,
            limit,
            offset,
            search_term: "",
          };
          dispatchGetAllStockItem(finalData);
        }
      }
    },
    500,
    [stockItemText]
  );

  useEffect(() => {
    if (!useTemplateId) {
      if (outputData?.length > 0) {
        let amount = 0;
        let qty = 0;
        outputData?.map((item: BomOutputType) => {
          amount += +item.amount;
          qty += +item?.quantity;
        });
        setTotal((prev: any) => ({ ...prev, output: { qty, amount } }));
      } else {
        setTotal((prev: any) => ({ ...prev, output: { qty: 0, amount: 0 } }));
      }
    }
  }, [outputData]);


  useEffect(() => {
    if (dateOfBom?.length) {

      let splitedInvoiceDate: string[] = dateOfBom ? dateOfBom?.split("-") : "";
      let splitedLockedEntries: string | string[] = lockBOMEntriesDate
        ? lockBOMEntriesDate?.split("-")
        : "";
      let itemDate = new Date(
        +splitedInvoiceDate[2],
        +splitedInvoiceDate[1] - 1,
        +splitedInvoiceDate[0]
      );
      let lockedDate = new Date(
        +splitedLockedEntries[2],
        +splitedLockedEntries[1] - 1,
        +splitedLockedEntries[0]
      );

      if (itemDate <= lockedDate) {
        setIsEntryLocked(true);
      } else {
        setIsEntryLocked(false);
      }
    }
  }, [dateOfBom, lockBOMEntriesDate]);


  useEffect(() => {
    if (!useTemplateId) {
      setBomHeaderData((prev: BomHeaderType) => ({
        ...prev,
        amount: changeToDecimel(+bomTempHeaderData?.amount)?.toString(),
        rate: ((+(
          +total?.input?.amount +
          (total?.totalAdditionalCost ? total?.totalAdditionalCost : 0)
        ) -
          +total?.output?.amount) /
          (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1)
          ? (+(
            +total?.input?.amount +
            (total?.totalAdditionalCost ? total?.totalAdditionalCost : 0)
          ) -
            +total?.output?.amount) /
          (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1)
          : 0
        )?.toFixed(2),
      }));
    }
  }, [bomTempHeaderData, total]);

  useEffect(() => {
    if (showImagePreview && uploadData?.length && !useTemplateId) {
      getImageDetails({ ...uploadData[0] }, 0);
    }
  }, [showImagePreview, uploadData]);

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const handleUploadFile = (data: any, fileData: any) => {
    setImageDetails(data);
    setShowFileUploadModal(false);
    setUploadData((prevUploadData: any) => [...prevUploadData, data]);
  };

  const handlePrimaryBatchOpen = () => {
    dispatchResetMappedStockBatchList();
    setIsMenuOpen(true);
    setDropDownType("primary")
    if (selectedStockId) {
      let finalData = {
        token,
        clientCode: client_code,
        stockId: selectedStockId,
        isEnable: 1,
      };
      dispatchGetStockMappedBatchListAction(finalData);
    }
  }

  const handleGetSelectedbatch = (index: any, data: any, type: string) => {
    dispatchResetMappedStockBatchList();
    setIsMenuOpen(true);

    setInputItemBatchIndex(index)
    setDropDownType(type)
    if (data?.value) {
      let finalData = {
        token,
        clientCode: client_code,
        stockId: data?.value,
        isEnable: 1,
      };
      dispatchGetStockMappedBatchListAction(finalData);
    }
  }


  const handleEditFileList = (index: number) => {
    const updatedFiles = [...uploadData];
    setUploadData(updatedFiles?.filter((e: any) => e?.file_url !== index));
  };

  const renderFilesList = () => {
    const isDelete = false;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        return singleImagePreview(
          data,
          index,
          getImageDetails,
          handleEditFileList,
          setShowPopUpContentModal,
          isDelete,
          uploadData
        );
      });
    return finalFileList;
  };

  const showUploadModal = () => {
    toggleModal(!modal);
  };

  const checkStockItemTypeBottom = () => {
    setoffset((prv: any) => prv + limit);
  };
  const checkBranchTypeBottom = () => {
    setBatchOffset((prv: any) => {
      const newValue = prv + limit;
      return newValue;
    });

  };

  const handleUseTemplateId = (id: any) => {
    setUseTemplateId?.(id?.toString());
    dispatchResetSingleBomTemplateData();
  };


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      }
      else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              window.scrollTo(0, 0);
              dispatchResetError();
              dispatchResetSuccess();
            }}
          />
        );
      }
    }

    else if (message === "Bill of material has been added successfully!") {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={!!message}
          title="Success"
          message={
            isTemplate
              ? "Template Saved & Manufacturing Journal Added Successfully!"
              : "Manufacturing Journal Added Successfully!"
          }
          buttonText="OK"
          onPress={() => {
            dispatchResetError();
            dispatchResetSuccess();
            history.push({
              pathname: `/invoice-generation/${client_code}#manufacturing`,
              state: { client_code, company_name },
            });
          }}
        />
      );
    }
  };

  return (
    <>
      {useTemplateId ? (
        <EditBillOfMaterial
          templateId={useTemplateId}
          isInputEdit="isInputEdit"
          companyName={company_name}
          history={history}
        />
      ) : (
        <div className="bill_of_material">
          <div className="col-md-6">
            <CommonHeader
              title={`Add Manufacturing Journal`}
              company_name={company_name}
              client_code={client_code}
              style={{ marginLeft: "-50px" }}
            />
          </div>
          {!useTemplateId ? (
            <BomAddEditFormDetails
              isAccordianOpen={isAccordianOpen}
              type="Add"
              template={template}
              history={history}
              isError={isError}
              inputData={inputData}
              offset={offset}
              bomTempHeaderData={bomHeaderData}
              uploadData={uploadData}
              showUploadModal={showUploadModal}
              persistHeaderQuantity={persistHeaderQuantity}
              persistInputType={persistInput}
              finalStockItemOptions={finalStockItemOptions}
              commentData={commentData}
              total={total}
              setCommentData={setCommentData}
              bomHeaderError={bomHeaderError}
              setIsError={setIsError}
              setBomHeaderError={setBomHeaderError}
              setPersistHeaderQuantity={setPersistHeaderQuantity}
              setPersistInputType={setPersistInput}
              setFinalStockItemDetailsOptions={setFinalStockItemDetailsOptions}
              setFinalStockItemOptions={setFinalStockItemOptions}
              setInputData={setInputData}
              setIsAccordianOpen={setIsAccordianOpen}
              setShowImagePreview={setShowImagePreview}
              setOutputData={setOutputData}
              checkStockItemTypeBottom={checkStockItemTypeBottom}
              setStockItemText={setStockItemText}
              bomInstallationData={bomInstallationData}
              bomHeaderData={bomHeaderData}
              outputData={outputData}
              finalStockItemDetailsOptions={finalStockItemDetailsOptions}
              setTotal={setTotal}
              setBomInstallationData={setBomInstallationData}
              setBomHeaderData={setBomHeaderData}
              setBomTempHeaderData={setBomTempHeaderData}
              handleUseTemplateId={handleUseTemplateId}
              setIsTemplate={setIsTemplate}
              isEntryLocked={isEntryLocked}
              dateOfBom={dateOfBom}
              setDateOfBom={setDateOfBom}
              setIsEntryLocked={setIsEntryLocked}
              setFinalBatchNumberOptions={setFinalBatchNumberOptions}
              batchManagementList={mappedStockBatchList}
              finalBatchNumberOptions={finalBatchNumberOptions}
              checkBranchTypeBottom={checkBranchTypeBottom}
              batchOffset={batchOffset}
              limit={limit}
              setBatchOffset={setBatchOffset}
              setSelectedStockId={setSelectedStockId}
              setSelectedInputItemStock={setSelectedInputItemStock}
              handletoggleRowInput={handletoggleRowInput}
              handletoggleRowOutput={handletoggleRowOutput}
              handleGetSelectedbatch={handleGetSelectedbatch}
              inputItemBatchIndex={inputItemBatchIndex}
              setInputItemBatchIndex={setInputItemBatchIndex}
              dropDownType={dropDownType}
              setDropDownType={setDropDownType}
              handlePrimaryBatchOpen={handlePrimaryBatchOpen}
              isMenuOpen={isMenuOpen}
            />
          ) : null}

          {modal ? (
            <MultipleUpload
              modal={modal}
              toggleModal={showUploadModal}
              containerName={containerName}
              handleUploadFile={handleUploadFile}
              isDraggableModal
              acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
              supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
              uploadSuccessArray={uploadSuccessArray}
              setUploadSuccessArray={setUploadSuccessArray}
            />
          ) : null}
          {showImagePreview && (
            <ImageModal
              showImagePreview={showImagePreview}
              setShowImagePreview={setShowImagePreview}
              resetImageUrl={resetImageUrl}
              imageDetails={imageDetails}
              renderFilesList={renderFilesList}
              uploadData={uploadData}
              setUploadData={setUploadData}
              type={"jobDetails"}
              handleEditFileList={handleEditFileList}
              isDelete={true}
            />
          )}

          {handleErrorModal()}
          <Toaster />
          {!template && fetching && <Loader />}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  error: state.invoiceGeneration.error,
  currencySign: state.auth.currencySign,
  message: state.invoiceGeneration.message,
  statuscode: state.invoiceGeneration.statusCode,
  businessAddressList: state.clientSettings.businessAddressList,
  allStockItemList: state.clientSettings.allStockItemList,
  multipleStockItemQuantityData:
    state.clientSettings.multipleStockItemQuantityData,
  stockFetching: state.clientSettings.fetching,
  fileManagerFetching: state.fileManager.fetching,
  stockItemListTotal: state.clientSettings.stockItemListTotal,
  lockBOMEntriesDate: state.invoiceGeneration.lockBOMEntriesDate,
  mappedStockBatchList: state.clientSettings.mappedStockBatchList,
  mappedStockBatchListTotalCount: state.clientSettings.mappedStockBatchListTotalCount,
  batchSuccess: state.clientSettings.success,
  batchError: state.clientSettings.error,
  batchMessage: state.clientSettings.message,


});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetError: () => dispatch(resetInvoiceGenerationError()),
  dispatchResetStockItemList: () => dispatch(resetStockItemList()),
  dispatchResetStockItemTotal: () => dispatch(resetStockItemListTotal()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetInvoiceGenerationError: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchGetMultipleStockItemQuantityAction: (
    data: StockMultipleItemQuantityRatePayloadType
  ) => dispatch(getMultipleStockItemQuantityAction(data)),
  dispatchResetBomSingleDataAction: () => resetSingleBomData(),
  dispatchResetMultipleStockItemData: () =>
    dispatch(resetMultipleStockItemQuantityData()),
  dispatchPostBomDataAction: (data: BomDataPayloadType) =>
    dispatch(postBomDataAction(data)),
  dispatchResetSingleBomTemplateData: () =>
    dispatch(resetSingleBomTemplateData()),
  dispatchGetStockMappedBatchListAction: (
    data: GetStockMappedBatchListPayloadType
  ) => dispatch(getStockMappedBatchListAction(data)),
  dispatchResetMappedStockBatchList: () =>
    dispatch(resetMappedStockBatchList()),
  dispatchResetMappedStockBatchListTotalCount: () =>
    dispatch(resetMappedStockBatchListTotalCount()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),

});

export default connect(mapStateToProps, mapDispatchToProps)(AddBillOfMaterial);
